import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "list-style-position-inside q-pa-none flex column gap-sm q-ma-none"
}
const _hoisted_3 = ["innerHTML"]

interface IProps {
  model?: 'info' | 'warning' | 'error'
  title?: string
  titleClass?: string
  icon?: string
  iconColor?: string
  iconStroke?: string
  hasIcon?: boolean
  description: string | string[]
  variant?: 'normal' | 'minimal'
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KAlert' },
  __name: 'KAlert',
  props: {
    model: { default: 'info' },
    title: { default: '' },
    titleClass: { default: '' },
    icon: { default: '' },
    iconColor: { default: '' },
    iconStroke: { default: '' },
    hasIcon: { type: Boolean, default: true },
    description: {},
    variant: { default: 'normal' }
  },
  setup(__props: any) {





const convertIcon = {
  info: 'info',
  error: 'remove-solid',
  warning: 'attention',
}

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["KAlert rounded-16", [
      __props.model === 'warning' ? 'bg-caution-20' : `bg-${__props.model}-20`,
      __props.variant === 'normal' ? 'q-pa-sm' : 'row no-wrap reverse items-start gap-sm q-py-12 q-pl-12 q-pr-md',
    ]])
  }, [
    (__props.variant === 'normal')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["rounded-12 q-pa-sm flex items-center", [__props.model === 'warning' ? 'bg-caution-50 text-caution-100' : `bg-${__props.model}-50 text-${__props.model}-100`]])
        }, [
          _renderSlot(_ctx.$slots, "title", {}, () => [
            (__props.hasIcon)
              ? (_openBlock(), _createBlock(_component_KIcon, {
                  key: 0,
                  class: "q-mr-xs",
                  size: "20px",
                  color: __props.iconColor,
                  stroke: __props.iconStroke,
                  name: !__props.icon ? convertIcon[__props.model] : __props.icon
                }, null, 8 /* PROPS */, ["color", "stroke", "name"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("p", {
              class: _normalizeClass(["q-mb-none fs-15px fw-500", [__props.titleClass, { 'text-capitalize': !__props.title }]])
            }, _toDisplayString(!__props.title ? __props.model : __props.title), 3 /* TEXT, CLASS */)
          ])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (__props.description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["text-cool-gray-80 fs-13px fw-400", { 'q-mb-none q-px-sm q-pt-sm q-pb-xs': __props.variant === 'normal' }])
        }, [
          (typeof __props.description === 'string')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                innerHTML: __props.description
              }, null, 8 /* PROPS */, _hoisted_1))
            : (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.description, (text, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    innerHTML: text
                  }, null, 8 /* PROPS */, _hoisted_3))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      (__props.variant === 'minimal')
        ? (_openBlock(), _createBlock(_component_KIcon, {
            key: 0,
            size: "20px",
            color: __props.iconColor,
            stroke: __props.iconStroke,
            name: !__props.icon ? convertIcon[__props.model] : __props.icon
          }, null, 8 /* PROPS */, ["color", "stroke", "name"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}
}

})